import { useEffect, useRef, useState } from "react";
import { FileTextOutlined} from '@ant-design/icons';
import instance from '@/api/http.js';

export function getHtml(url) {
    return instance({
        url,
        method: "get"
    })
}

export function transformTime(timestamp = +new Date(), type) {
  if (timestamp) {
      var time = new Date(timestamp);
      var y = time.getFullYear(); //getFullYear方法以四位数字返回年份
      var M = time.getMonth() + 1; // getMonth方法从 Date 对象返回月份 (0 ~ 11)，返回结果需要手动加一
      var d = time.getDate(); // getDate方法从 Date 对象返回一个月中的某一天 (1 ~ 31)
      var h = time.getHours(); // getHours方法返回 Date 对象的小时 (0 ~ 23)
      var m = time.getMinutes(); // getMinutes方法返回 Date 对象的分钟 (0 ~ 59)
      var s = time.getSeconds(); // getSeconds方法返回 Date 对象的秒数 (0 ~ 59)
      if (type==='day') {
        return y + '/' + M + '/' + d;
      } else {
        return y + '-' + M + '-' + d + ' ' + h + ':' + m + ':' + s;
      }
    } else {
        return '';
    }
}

export const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
      // 每次在value变化以后，设置一个定时器
      const timeout = setTimeout(() => setDebouncedValue(value), delay);
      // 每次在上一个useEffect处理完以后再运行
      return () => clearTimeout(timeout);
    }, [value, delay]);
    return debouncedValue;
};

export const useDocumentTitle = (title, keepOnUnmount = true) => {
    const oldTitle = useRef(document.title).current;
    // 页面加载时: 旧title
    // 加载后：新title
    useEffect(() => {
      document.title = title;
    }, [title]);
  
    useEffect(() => {
      return () => {
        if (!keepOnUnmount) {
          // 如果不指定依赖，读到的就是旧title
          document.title = oldTitle;
        }
      };
    }, [keepOnUnmount, oldTitle]);
};

export const useDocumentdescription = (description, keepOnUnmount = true) => {
  const olddescription = useRef(document.querySelector('meta[name="description"]').getAttribute('content')).current;
  // 页面加载时: 旧description
  // 加载后：新description
  useEffect(() => {
    document.querySelector('meta[name="description"]').setAttribute('content', description);
  }, [description]);

  useEffect(() => {
    return () => {
      if (!keepOnUnmount) {
        // 如果不指定依赖，读到的就是旧description
        document.querySelector('meta[name="description"]').setAttribute('content', olddescription);
      }
    };
  }, [keepOnUnmount, olddescription]);
};


export const useDocumentkeywords = (keywords, keepOnUnmount = true) => {
  const oldkeywords = useRef(document.querySelector('meta[name="keywords"]').getAttribute('content')).current;
  // 页面加载时: 旧keywords
  // 加载后：新keywords
  useEffect(() => {
    document.querySelector('meta[name="keywords"]').setAttribute('content', keywords);
  }, [keywords]);

  useEffect(() => {
    return () => {
      if (!keepOnUnmount) {
        // 如果不指定依赖，读到的就是旧keywords
        document.querySelector('meta[name="keywords"]').setAttribute('content', oldkeywords);
      }
    };
  }, [keepOnUnmount, oldkeywords]);
};



/**
 * 返回组件的挂载状态，如果还没挂载或者已经卸载，返回false；反之，返回true
 */
 export const useMountedRef = () => {
    const mountedRef = useRef(false);
    useEffect(() => {
      mountedRef.current = true;
      return () => {
        mountedRef.current = false;
      };
    });
    return mountedRef;
};
/* eslint-disable */
export const isMobile= () => {
  var sUserAgent = navigator.userAgent.toLowerCase();
  var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
  var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
  var bIsMidp = sUserAgent.match(/midp/i) == "midp";
  var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
  var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
  var bIsAndroid = sUserAgent.match(/android/i) == "android";
  var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
  var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
  if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid ||bIsCE || bIsWM) {
    // console.log("手机登录");
     return true;
  } else {
    return false;
  }
}

export function convertToTreedata(treedata,id){
  let returnData = [];
  //遍历数据
  for(var i = 0; i < treedata.length; i++){
      let haslast=Boolean(treedata[i].children&&treedata[i].children.length || treedata[i].articles&&treedata[i].articles.count);
      var tempObj = {
          title : treedata[i].title||treedata[i].name,
          key : `${id?id:''}-${treedata[i].id}`,
          url: treedata[i].contentUrl||treedata[i].url,
          hasPassword: treedata[i].hasPassword,
          fileUrl: treedata[i].fileUrl,
          hasFile: treedata[i].hasFile,
          hasForm: treedata[i].hasForm,
          selectable: !treedata[i].name || !haslast,
          isName: !treedata[i].title,
          isLeaf: !treedata[i].name,
          member: treedata[i].member&&treedata[i].member,
          remark: treedata[i].remark&&treedata[i].remark,
          icon: !treedata[i].title?null:<FileTextOutlined />
      };
      //判断是否存在子节点，如果存在则递归
      let concatData = treedata[i].children?treedata[i].children.concat(treedata[i].articles.data) : [];
      if(concatData.length){
          tempObj.children = convertToTreedata(concatData,treedata[i].id);
      }
      //push到数据数组中
      let isclick = !treedata[i].name || !haslast;
      let isAdd = !treedata[i].title;
      if(!isAdd || !isclick ) {
        returnData.push(tempObj);
      }  
  }
  return returnData;
}

export function noFindPathByLeafId(nodes, path){
  if(path === undefined) {
    path = {};
  }
  for(var i = 0; i < nodes.length; i++) {
      var tmpPath = path;
      if(!nodes[i].selectable) {
        tmpPath=nodes[i];
        return tmpPath;
      }
      if(nodes[i].children) {
        var findResult = noFindPathByLeafId(nodes[i].children, tmpPath);
        if(findResult) {
          return findResult;
        }
      }
  }
}


export function getAllParentArr(list, key) {
  for (let i in list) {
    if (list[i].key === key) {
      //查询到返回该数组对象
      return [list[i]];
    }
    if (list[i].children) {
      let node = getAllParentArr(list[i].children, key);
      if (node !== undefined) {
        //查询到把父节点连起来
        return node.concat(list[i]);
      }
    }
  }
}


export function findPathByLeafId(leafId, nodes, path){
    if(path === undefined) {
      path = {};
    }
    for(var i = 0; i < nodes.length; i++) {
        var tmpPath = path;
        if(leafId == nodes[i].key) {
          tmpPath=nodes[i];
          return tmpPath;
        }
        if(nodes[i].children) {
          var findResult = findPathByLeafId(leafId, nodes[i].children, tmpPath);
          if(findResult) {
            return findResult;
          }
        }
    }
}

// antd tree树形匹配方法
export function getParentKey( key, tree) {
  let parentKey
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (node.children.some((item) => item.key === key)) {
        parentKey = node.key;
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children);
      }
    }
  }
  return parentKey;
}
